import { View, Text } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const obligations = [
  {
    title: "By 3 Month’s Written Notice",
    content:
      "This Contract may be terminated at any time by either party giving to the other not less than 3 month’s prior written notice.",
  },
  {
    title: "Immediately with Notice",
    content:
      "This Contract may be terminated by the Company immediately by written notice to the Appointed Representative on the occurrence of any of the following events:",
    clauses: [
      {
        content:
          "Where in the reasonable opinion of the Company the Appointed Representative ceases to be fit and proper under the Regulations.",
      },
      {
        content:
          "Failure by the Appointed Representative or any of its personnel to achieve and maintain the necessary level of competence (in accordance with the Regulations or company minimum standards).",
      },
      {
        content:
          "Disqualification of the Appointed Representative or any of its personnel as a Director under the Company Directors’ Disqualification Act 1986.",
      },
      {
        content:
          "Any breach of confidentiality under clause 4.6 of this Contract.",
      },
      {
        content:
          "Any purported assignment of this Contract by the Appointed Representative in breach of clause 4.7 of this Contract.",
      },
    ],
  },
  {
    title: "Immediately without Notice",
    content:
      "This contract shall terminate immediately without notice on the occurrence of any of the following events:",
    clauses: [
      {
        content: "Insolvency.",
      },
      {
        content:
          " As the Appointed Representative is a private limited company, if the company or any Directors, shareholders or any of the partners shall have a bankruptcy order made against them, or if a person who is qualified to act as an insolvency practitioner shall be appointed in relation to them.",
      },
      {
        content:
          "Where the Appointed Representative is a company or LLP, then in the event of an Appointed Representative going into liquidation (other than voluntary liquidation for the purpose of amalgamation or reconstruction) or being unable to pay its debts within the meaning of s.123 of the Insolvency Act 1986 or suffering a distress or execution to be levied on or a receiver appointed over any property used in connection with the Appointed Representative’s business or if the Appointed Representative makes any arrangements with its creditors or if any administrator is appointed under the Insolvency Act 1986.",
      },
      {
        content:
          "Revocation of approved person status of the Appointed Representative or where applicable any of its personnel by the FCA.",
      },
      {
        content:
          "The death or incapacity of the Director of the Appointed Representative, if the Appointed Representative is an individual. However, if the Appointed Representative is a firm, the provisions of Clause 9.1 shall apply.",
      },
    ],
  },
];

const Termination = ({ serialNumber = 7 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]}>
      <ContractListItem
        id="termination"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Termination
      </ContractListItem>
      <Text style={styles.buttonTextSmall}>
        The Company agrees with the Appointed Representative:
      </Text>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default Termination;
